import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M10 6.24967V9.99967L12.5 12.4997M17.9167 9.99967C17.9167 14.3719 14.3723 17.9163 10 17.9163C5.62779 17.9163 2.08337 14.3719 2.08337 9.99967C2.08337 5.62742 5.62779 2.08301 10 2.08301C14.3723 2.08301 17.9167 5.62742 17.9167 9.99967Z",
      stroke: "currentColor",
      "stroke-linecap": "square",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }